import { BodyCopy } from "./BodyCopy";

type FooterDetailSummaryProps = {
  heading: string;
  fee: string;
  total: string;
  titleColor: string;
  textColor: string;
};

/** Bordered transfer-footer card: Detalle / fee / total payment. */
export const FooterDetailSummary = ({
  heading,
  fee,
  total,
  titleColor,
  textColor,
}: FooterDetailSummaryProps) => (
  <section className="footer-summary">
    <BodyCopy className="footer-text footer-summary-title" textColor={titleColor}>
      <b>{heading}</b>
    </BodyCopy>
    <BodyCopy className="footer-text" textColor={textColor}>
      {fee}
    </BodyCopy>
    <BodyCopy className="footer-text" textColor={textColor}>
      {total}
    </BodyCopy>
  </section>
);
